import { Laugh, Users, Zap } from "lucide-react";
import Mascot from "./Mascot";
import Reveal, { SectionHead } from "./Reveal";

const CARDS = [
    {
        n: "01",
        title: "MEMES",
        body: "The internet runs on memes. So that's exactly what we're building.",
        icon: Laugh,
        accent: "text-cyan-300 border-cyan-400/30",
    },
    {
        n: "02",
        title: "COMMUNITY",
        body: "The community is the project.",
        icon: Users,
        accent: "text-purple-300 border-purple-400/30",
    },
    {
        n: "03",
        title: "BALD ENERGY",
        body: "No hair. No brakes. Just $BALD.",
        icon: Zap,
        accent: "text-green-300 border-green-400/30",
    },
];

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="relative scroll-mt-24 py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-8">
                    <div>
                        <SectionHead
                            align="left"
                            kicker="ABOUT"
                            title="WHAT IS $BALD?"
                        />
                        <Reveal delay={0.1}>
                            <div className="mt-6 space-y-5 text-base md:text-lg leading-relaxed text-slate-300">
                                <p>
                                    $BALD is a community-driven Solana memecoin built around one simple idea:
                                </p>
                                <p className="font-bold text-white">
                                    What happens when a pigeon loses its hair?
                                </p>
                                <p className="font-display text-2xl uppercase text-gradient">BALD PIGEON.</p>
                                <p>That's it.</p>
                                <p>
                                    No complicated lore.
                                    <br />
                                    No fake utility.
                                    <br />
                                    No corporate presentation.
                                </p>
                                <p>
                                    Just a meme, a community and a bald pigeon trying to conquer the internet.
                                </p>
                            </div>
                        </Reveal>
                    </div>
                    <Reveal delay={0.15} className="relative">
                        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(168,85,247,0.14),transparent_60%)]" />
                        <Mascot
                            name="about"
                            className="mx-auto w-full max-w-sm lg:max-w-md drop-shadow-[0_20px_50px_rgba(0,240,255,0.14)]"
                        />
                    </Reveal>
                </div>

                <div className="mt-16 grid gap-5 md:grid-cols-3">
                    {CARDS.map((c, i) => (
                        <Reveal key={c.n} delay={i * 0.12} className="h-full">
                            <div
                                data-testid={`about-card-${c.n}`}
                                className="glass glass-hover flex h-full flex-col gap-4 rounded-2xl p-6 lg:p-8"
                            >
                                <div className="flex items-center justify-between">
                                    <span className="font-mono text-sm font-bold text-slate-500">{c.n}</span>
                                    <c.icon className={`h-6 w-6 ${c.accent.split(" ")[0]}`} />
                                </div>
                                <h3 className={`headline text-2xl ${c.accent.split(" ")[0]}`}>{c.title}</h3>
                                <p className="text-slate-400">{c.body}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
